import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export async function submitContactInquiry(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

export async function submitQuoteRequest(payload) {
  const { data } = await api.post("/quote", payload);
  return data;
}
